import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")

import AddEdit from "./part/add-edit.vue";
import AddEditOps from "./part/add-edit-ops.vue";
import { onMounted, reactive, ref, getCurrentInstance, computed } from "vue";
import { ElMessage } from "element-plus";


const __default__ = {
  name: "RoleConfigManagement",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  curUser: {
    type: Object,
  },
  terminal: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props



const { proxy } = getCurrentInstance() as any;
const addRef = ref<any>(null);
const state = reactive({
  roleStatus: [
    { label: "启用", value: false },
    { label: "停用", value: true },
  ],
  form: {} as any,
  paginationInfo: {
    total: 0,
    pageSize: 10,
    page: 1,
  },
  listData: [],
  roleId: "",
  VisionLevelKindPocket: [] as any,
  tenantAll: [],
});

// 分页
const onSearch = async (current: number) => {
  state.paginationInfo.page = current;
  const { page, pageSize } = state.paginationInfo;
  const apis = {
    ops: "/ops/role/page",
    mgr: "/role/page",
  };
  const params = {
    ...state.form,
    page: page,
    size: pageSize,
  };
  if (state.form.tenantAndShop) {
    params.tenantId = state.form.tenantAndShop[0];
    params.shopId = state.form.tenantAndShop[1];
    delete params.tenantAndShop;
  }
  // 当前登录账号权限等级
  const currentRole = props?.curUser?.currentRole;
  state.roleId = currentRole?.id;
  const [res] = (await proxy.$api.post(apis[props.terminal], params)) || [];
  state.tenantAll = proxy?.pocket("TenantAll");
  state.VisionLevelKindPocket = proxy?.pocket("VisionLevelKind");

  if (res) {
    state.listData = res.content;
    state.paginationInfo.total = res.totalElements;
  }
};

const sizeChange = (size: number) => {
  state.paginationInfo.pageSize = size;
  onSearch(1);
};

const confimForm = (res: any) => {
  state.form = { ...res };
  onSearch(state.paginationInfo.page);
};

// 新建
const add = () => {
  let modalParams = {
    VisionLevelKindPocket: state.VisionLevelKindPocket,
  };
  addRef.value.active(modalParams);
};

// 编辑
const roleEdit = (row: any) => {
  let modalParams = {
    ...row,
    VisionLevelKindPocket: state.VisionLevelKindPocket,
  };
  addRef.value.active(modalParams);
};

// 启用停用
const openOrClose = async (row: any) => {
  if (props.terminal === "ops") {
    var openApi = `/ops/role/enable/${row.id}`;
    var closeApi = `/ops/role/disable/${row.id}`;
  } else {
    var openApi = `/role/enable/${row.id}`;
    var closeApi = `/role/disable/${row.id}`;
  }
  const params = {
    ...row,
  };
  const api = !row.disabled ? closeApi : openApi;
  const [res] = await proxy.$api.post(api, params);
  if (res) {
    ElMessage({
      message: `已${!row.disabled ? "停用" : "启用"}角色`,
      type: "success",
    });
    onSearch(1);
  }
};

onMounted(() => {
  onSearch(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_mas_table = _resolveComponent("mas-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_mas_form_main, {
      form: _unref(state).form,
      defaultFormFooterConfirmText: "搜索",
      defaultFormFooterButton: ['confirm', 'reset'],
      onConfim: confimForm,
      inline: true,
      style: {"background-color":"#ffffff","padding-top":"20px","padding-left":"20px","margin-bottom":"10px"}
    }, {
      content: _withCtx((slotProps) => [
        (_ctx.$props.terminal === 'ops')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "租户门店"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: slotProps.content.tenantAndShop,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantAndShop) = $event),
                  placeholder: "请选择租户门店",
                  props: { checkStrictly: true },
                  options: _unref(state).tenantAll,
                  filterable: "",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "disabled"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: slotProps.content.disabled,
              "onUpdate:modelValue": ($event: any) => ((slotProps.content.disabled) = $event),
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).roleStatus, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.label,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_el_form_item, {
          label: "模糊搜索",
          prop: "queryText"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: slotProps.content.queryText,
              "onUpdate:modelValue": ($event: any) => ((slotProps.content.queryText) = $event),
              placeholder: "输入角色名称"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_component_mas_table, {
      ref: "masTableRef",
      pageConfig: _unref(state).paginationInfo,
      tableAttrs: {
        data: _unref(state).listData,
      },
      paginationListeners: {
        currentChange: onSearch,
        sizeChange: sizeChange,
      }
    }, {
      "tool-right": _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "角色名称",
          prop: "name",
          width: "240"
        }),
        _createVNode(_component_el_table_column, {
          label: "角色说明",
          prop: "description",
          width: "260"
        }),
        _createVNode(_component_el_table_column, {
          label: "使用门店",
          prop: "shopName",
          width: "260"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.shopName || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "用户人数",
          prop: "userCount",
          width: "240"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "disabled",
          width: "240"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.disabled ? "停用" : "启用"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          "min-width": "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (roleEdit(row))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": "是",
              "cancel-button-text": "否",
              "icon-color": "red",
              "popper-class": "hbb-work-fff",
              title: 
                row.disabled
                  ? '此操作将启用本角色，启用后可配置给员工，是否继续？'
                  : row.userCount
                  ? `本角色目前有${row.userCount}个用户在使用，停用后相关用户将无法使用当前角色，是否继续？`
                  : '此操作将停用本角色，停用后不可配置给员工，是否继续？'
              ,
              onConfirm: ($event: any) => (openOrClose(row))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "text",
                  class: _normalizeClass(row.id === _unref(state).roleId ? 'disabled' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.disabled ? "启用" : "停用"), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["title", "onConfirm"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["pageConfig", "tableAttrs", "paginationListeners"]),
    (__props.terminal === 'mgr')
      ? (_openBlock(), _createBlock(AddEdit, {
          key: 0,
          ref_key: "addRef",
          ref: addRef,
          onConfim: _cache[0] || (_cache[0] = ($event: any) => (onSearch(1)))
        }, null, 512))
      : _createCommentVNode("", true),
    (__props.terminal === 'ops')
      ? (_openBlock(), _createBlock(AddEditOps, {
          key: 1,
          ref_key: "addRef",
          ref: addRef,
          onConfim: _cache[1] || (_cache[1] = ($event: any) => (onSearch(1)))
        }, null, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})